$(function() {
  function insertIfUnique(key, obj) {
    for (var k in obj) {
      if (obj[k] == key) {
        return obj;
      }
    }

    obj.push(key);

    return obj;
  }

  function _clickListener(click, col, row) {
    return function(e) {
      click(e, col, row);
    };
  }

  function createArray(low, len) {
    var arr = [];

    for (var i = 0; i < len; i++) {
      arr.push(i + low);
    }

    return arr;
  }

  var antalSelection = $('#Quantity[type=number]').length > 0;
  var quantity = $('#Quantity');

  if (window.productInfo.skewedQuantity) {
    setAntal();
  }

  function createTable(header, rows, opts) {
    var table = opts.table || document.createElement('table');

    while (table.hasChildNodes()) {
      table.removeChild(table.lastChild);
    }

    var theader = document.createElement('tr');

    for (var i = 0; i < header.length; i++) {
      var th = document.createElement('th');
      var text = document.createElement('span');
      text.innerText = header[i];

      if (i == 0) {
        text.innerHTML = '<p class="modal-banner hidden-xs hidden-sm">Priseksempler</p>';
      }

      var button = document.createElement('a');

      if (i == 1 && opts.left && antalSelection) {
        button.onclick = function() {
          opts.left && opts.left(table);
        };

        button.innerHTML = '&lt;';
        button.className = 'left-arrow';
        th.appendChild(button);
        th.appendChild(text);
      } else if (i == header.length - 1 && opts.right && antalSelection) {
        button.onclick = function() {
          opts.right && opts.right(table);
        };

        button.innerHTML = '&gt;';
        button.className = 'right-arrow';
        th.appendChild(text);
        $('.price-table-wrapper').append(button);
      } else {
        th.appendChild(text);
      }

      theader.appendChild(th);
    }

    table.appendChild(theader);

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var trow = document.createElement('tr');

      for (var j = 0; j < row.length; j++) {
        var td = document.createElement('td');
        td.innerText = row[j];

        if (j > 0 && opts.select) {
          td.addEventListener('click', _clickListener(opts.select, i, j));
        }

        trow.appendChild(td);
      }

      table.appendChild(trow);
    }

    return table;
  }

  $('a[data-target=".price-table-modal"]').show();
  if (window.productInfo.areaPayment) {
    $('a[data-target=".price-table-modal"]').hide();
    console.log('hiding');
  }
  $('.price-table-modal').click(function(e) {
    if (/modal-content-wrapper/.exec(e.target.className)) {
      $('.price-table-modal').modal('hide');
      return;
    }
  });
  setCategoriesHeight();

  function updateTableContents(offset, table) {
    var options = $('.single-option-selector');
    var quantity = $('#Quantity');
    var produtPris = $('#ProductPrice');
    var antalSelection = $('#Quantity[type=number]').length > 0;
    var len = 5;

    var headerData = createArray(offset * len + 1, len);

    //Generate table header
    var theader = antalSelection
      ? ['Stk.'].concat(headerData)
      : window.productJSON.variants
        .map(function(variant) {
          return variant.options[variant.options.length - 1];
        })
        .concat(
          window.productInfo.skewedQuantity ? $('#sq-quantity').val() : []
        )
        .reduce(
          function(a, b) {
            var inArray = false;
            for (var i = 0; i < a.length; i++) {
              if (b === a[i]) {
                inArray = true;
                break;
              }
            }
            if (!inArray) {
              a.push(b);
            }
            return a;
          },
          []
        );

    if (window.productInfo.skewedQuantity) {
      theader.sort(function(a, b) {
        return parseInt(a, 10) > parseInt(b, 10);
      });
    }

    if (!antalSelection) theader.unshift('');

    var rows = [];

    // Generate table data
    if (antalSelection) {
      var tdata = window.productJSON.variants
        .map(function(variant) {
          var data = createArray(offset * len + 1, len).map(function(i) {
            return formatPrice(variant.price / 100 * i);
          });
          return [variant.title || window.productJSON.title].concat(data);
        })
        .filter(function(a) {
          return a;
        });
    } else if (window.productInfo.skewedQuantity) {
      var uniqueColumIds = [];
      var uniqueAmts = [];
      var priceLookUpTable = {};

      window.productJSON.variants.map(function(variant) {
        var d = /(.+\/.+)\s?\/\s+?([0-9]+)/ig.exec(variant.title);
        var key = d[1];
        var amt = d[2];

        insertIfUnique(key, uniqueColumIds);
        insertIfUnique(parseInt(amt, 10), uniqueAmts);

        priceLookUpTable[variant.title] = variant.price;
      });

      var tdata = uniqueColumIds.map(function(id) {
        return theader.map(function(header) {
          if (!header) {
            return id;
          }

          var amt = parseInt(header, 10);
          var choice = uniqueAmts[0];

          // defaulter til den laveste
          // find højeste mængde værdi der er mindre end vores tal
          for (var i = uniqueAmts.length - 1; i >= 0; --i) {
            if (uniqueAmts[i] <= amt) {
              choice = uniqueAmts[i];
              break;
            }
          }

          var priceScale = priceLookUpTable[id.trim() + ' / ' + choice];

          return formatPrice(amt * priceScale / 100);
        });
      });
    } else {
      var tdata = window.productJSON.variants
        .map(function(variant) {
          variantTitle = variant.name;
          var data = window.productJSON.variants
            .map(function(variantI) {
              if (
                variantTitle
                  .split(' / ')
                  .slice(0, variantTitle.split(' / ').length - 1)
                  .join(' / ') ===
                  variantI.name
                    .split(' / ')
                    .slice(0, variantI.name.split(' / ').length - 1)
                    .join(' / ')
              ) {
                var pris = variantI.price;

                return formatPrice(pris / 100);
              }
              return;
            })
            .filter(function(a) {
              return a;
            });
          // Title minus qty concat data
          var title = variantTitle
            .split(' / ')
            .slice(0, variantTitle.split(' / ').length - 1)
            .join(' / ');
          return [
            title.substring(title.indexOf(' - ') + 3) ||
              window.productJSON.title
          ].concat(data);
        })
        .filter(function(b, c, a) {
          f = a.slice(0, c);
          var inArray = false;
          for (var i = 0; i < f.length; i++) {
            if (b.join(',') === f[i].join(',')) {
              inArray = true;
              break;
            }
          }
          return !inArray;
        });
    }

    //Create table
    return createTable(theader, tdata, {
      table: table,
      left: offset > 0 ? function(table) {
          updateTableContents(offset - 1, table);
        } : void 0,
      right: function(table) {
        updateTableContents(offset + 1, table);
      },
      select: function(e, row, col) {
        var antal = antalSelection ? col + offset * len : theader[col];
        var variant = antalSelection
          ? window.productJSON.variants[row].options
          : (tdata[row][0] + ' / ' + antal).split(' / ');

        for (
          var i = 0;
          i < variant.length - (window.productInfo.skewedQuantity ? 1 : 0);
          i++
        ) {
          var option = variant[i].trim();
          var subs = option.split('//');
          if (subs.length > 1) {
            var sels = $('.productSelect-option-' + i);
            for (var j = 0; j < sels.length; j++) {
              $(sels[j]).val(subs[j]);
            }
          } else {
            $(
              '#productSelect-option-' +
                Math.max(0, window.productJSON.options.length > 1 ? i : i - 1)
            ).val(option);
          }
        }

        if (antalSelection) {
          quantity.val(antal);
        } else if (window.productInfo.skewedQuantity) {
          $('#sq-quantity').val(variant[variant.length - 1]);
          setAntal();
        }

        var evt = document.createEvent('HTMLEvents');
        evt.initEvent('change', false, true);
        $('.single-option-selector, #sq-quantity').each(function() {
          this.dispatchEvent(evt);
        });

        $('.price-table-modal').modal('hide');
      }
    });
  }

  var table = updateTableContents(0);

  $('#price-table').append(table);

  if (window.productInfo.skewedQuantity) {
    $('a[data-target=".price-table-modal"]').click(function() {
      updateTableContents(0, table);
    });
  }

  if (antalSelection) {
  } else if (!antalSelection && quantity) {
  } else {
    $('#order a[data-target=".price-table-modal"]').hide();
    $('#order').css('background-size', '40px auto');
    $('#order h1').css('margin-bottom', '15px');
  }
  if (productInfo.areaPayment) {
    $('#order a[data-target=".price-table-modal"]').hide();
    $('#order').css('background-size', '40px auto');
    $('#order h1').css('margin-bottom', '15px');
  }
});

function formatPrice(price) {
  var formattedPrice = price
    .toFixed(2)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+\,)/g, '$1.');

  formattedPrice = formattedPrice.replace(',00', ',-');

  return formattedPrice;
}
